let config = require('./config.global')

config.env = 'development'
config.hostname = 'localhost'
config.mongo.db = 'local_db'

config.api.delivery = 'http://localhost:5501'
// config.api.delivery = 'https://api.darall.pro'
// config.api.kladr = 'http://localhost:5000'

module.exports = config;
